export const STORE_DEPARTMENTS_PREFIX = "StoreDepartments";

export const STORE_DEPARTMENTS_CLASSES = {
  title: `${STORE_DEPARTMENTS_PREFIX}-title`,
  departments: `${STORE_DEPARTMENTS_PREFIX}-departments`,
  hideOnMobile: `${STORE_DEPARTMENTS_PREFIX}-hideOnMobile`,
};
